/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What was uploaded. A Word form is edited as a document; a PDF on a coordinate canvas.
 */
export enum DocumentWorkflowTemplateSourceFormat {
    PDF = 'PDF',
    DOCX = 'DOCX',
}
